import jsSHA from "jssha";

export default function getAuthorizationHeader() {
  let APP_ID = process.env.REACT_APP_TDX_APP_ID;
  let APP_KEY = process.env.REACT_APP_TDX_APP_KEY;
  let GMTString = new Date().toGMTString();
  let ShaObj = new jsSHA("SHA-1", "TEXT", {
    hmacKey: { value: APP_KEY, format: "TEXT" }
  });
  ShaObj.update("x-date: " + GMTString);
  let HMAC = ShaObj.getHMAC("B64");
  let Authorization =
    'hmac username="' +
    APP_ID +
    '", algorithm="hmac-sha1", headers="x-date", signature="' +
    HMAC +
    '"';
  return {
    Authorization: Authorization,
    "X-Date": GMTString
  };
}
